import React, { FC } from 'react';
import { HrefLang, RegionWithLangs } from '@navi-toolbox/seo';
import { useSelector } from 'react-redux';
import { getHost } from '../page-model/ducks/get-model';
import { HelmetContext } from '@okapi/helmet-react';

type Props = {
  context: HelmetContext;
};

export const HrefLangMeta: FC<Props> = ({ context }) => {
  const regions: RegionWithLangs[] = [
    {
      regionCodeIS03166: 'ru',
      languagesISO639: ['ru'],
    },
    {
      regionCodeIS03166: 'kz',
      languagesISO639: ['ru', 'kk'],
    },
  ];
  const host = useSelector(getHost);
  const protocol = host?.includes('localhost') ? 'http://' : 'https://';

  return <HrefLang regions={regions} url={protocol + host + '/brands/'} context={context} />;
};
